module.exports = __webpack_public_path__ + "img/hk.f4605c6c.png";